// extracted by mini-css-extract-plugin
module.exports = {"container":"footerSubscribe_container__1--aj","title":"footerSubscribe_title__1i97X","text":"footerSubscribe_text__2Po7n","inputRow":"footerSubscribe_inputRow__18SJn","input":"footerSubscribe_input__1vtcr","btn":"footerSubscribe_btn__28X2Z","btnLabel":"footerSubscribe_btnLabel__3mA3W","btnArrow":"footerSubscribe_btnArrow__3DnPC"};
    if(module.hot) {
      // 1790670238755
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  